import React from 'react'
import axios from 'axios'
import constants from '../../../lib/constants'
import PropTypes from 'prop-types'
import Step from '../../../components/Step'
import Select from 'react-select'
import _ from 'lodash'
import PROPTYPES from '../../../lib/propTypes'
import * as validation from 'lib/validation'
import './SiteTools.scss'
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'
import { BeatLoader } from 'react-spinners'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { Link } from 'react-router'
import { withRouter } from 'react-router'

const FIRST_NAME = 'FirstName'
const LAST_NAME = 'LastName'
const PHONE_NUMBER = 'PhoneNumber'
const PHONE_NUMBER_TYPE = 'PhoneNumberType'
const EMAIL = 'Email'
const SITE = 'Site'
const PRESCRIBER = 'Prescriber'
const ADDRESS = 'Address'
const CONDITION1 = 'Contition1'
const CONDITION2 = 'Contition2'
const BLOOD_PRESSURE = 'BloodPressure'
const CARDIAC_CARE = 'CardiacCare'
const EKG = 'EKG'
const GLUCOSE = 'Glucose'
const HEART_RATE = 'HeartRate'
const PLATELET = 'Platelet'
const PULSE_OXIMETRY = 'PulseOximetry'
const TEMPERATURE = 'Temperature'
const WBC = 'WBC'
const WEIGHT = 'Weight'
const URINE_TOXICOLOGY = 'UrineToxicology'
const GENDER = 'Gender'
const RACE = 'Race'
const DATE_OF_BIRTH = 'DateOfBirth'
const PATIENT_TYPE = 'PatientType'
const INSURANCE_COMMERCIAL = 'InsuranceCommercial'
const INSURANCE_COMMERCIAL_COMPANY = 'InsuranceCommercialCompany'
const INSURANCE_COMMERCIAL_POLICY_NUMBER = 'InsuranceCommercialPolicyNumber'
const INSURANCE_MEDICARE = 'InsuranceMedicare'
const INSURANCE_MEDICARE_MEDICARE_ID = 'InsuranceMedicareMedicareId'
const INSURANCE_MEDICAID = 'InsuranceMedicaid'
const INSURANCE_MEDICAID_MEDICAID_ID = 'InsuranceMedicaidMedicaidId'
const INSURANCE_OTHER = 'InsuranceOther'
const INSURANCE_OTHER_DETAILS = 'InsuranceOtherDetails'
const INSURANCE_OTHER_GROUP_ID = 'InsuranceOtherGroupId'
const INSURANCE_OTHER_MONITORING_FREQUENCY = 'InsuranceOtherMonitoringFrequency'
const INSURANCE_OTHER_RX_BIN = 'InsuranceOtherRxBin'
const SOCIAL_SECURITY = 'SocialSecurity'
const CARETAKER_NAME = 'CaretakerName'
const IS_CONCIERGE = 'IsConcierge'
const IS_RPM = 'IsRPM'
const IS_CARDIAC_CARE_ENABLED = 'IsCardiacCareEnabled'

const SITE_EDIT = 'SiteEdit'
const PATIENT_EDIT = 'PatientEdit'
const BLOOD_PRESSURE_EDIT = 'BloodPressureEdit'
const EKG_EDIT = 'EKGEdit'
const GLUCOSE_EDIT = 'GlucoseEdit'
const HEART_RATE_EDIT = 'HeartRateEdit'
const PLATELET_EDIT = 'PlateletEdit'
const PULSE_OXIMETRY_EDIT = 'PulseOximetryEdit'
const TEMPERATURE_EDIT = 'TemperatureEdit'
const WBC_EDIT = 'WBCEdit'
const WEIGHT_EDIT = 'WeightEdit'
const URINE_TOXICOLOGY_EDIT = 'UrineToxicologyEdit'

class PatientCreationView extends React.Component {
  static propTypes = {
    isFetchingSites: PropTypes.bool,
    isFetchingPrescribers: PropTypes.bool,
    createPatient: PropTypes.func,
    sites: PROPTYPES.sites,
    prescribers: PROPTYPES.prescribers,
    router: PropTypes.shape({}),
    getPatients: PropTypes.func,
    isFetchingPatients: PropTypes.bool,
    patients: PROPTYPES.patients,
    updatePatient: PropTypes.func,
  }

  static defaultProps = {
    isFetchingSites: false,
    isFetchingPrescribers: false,
    createUser: _.noop,
    isFetchingPatients: false,
    patients: [],
    updatePatient: _.noop,
  }

  constructor (props) {
    super(props)
    this.state = {
      [`input${FIRST_NAME}`]: '',
      [`input${LAST_NAME}`]: '',
      [`input${DATE_OF_BIRTH}`]: '',
      [`selected${RACE}`]: '',
      [`selected${GENDER}`]: '',
      [`input${SITE}`]: '',
      [`input${PRESCRIBER}`]: '',
      [`input${PHONE_NUMBER}`]: '',
      [`input${PHONE_NUMBER_TYPE}`]: '',
      [`input${EMAIL}`]: '',
      [`input${ADDRESS}`]: '',
      [`selected${ADDRESS}`]: '',
      [`input${INSURANCE_COMMERCIAL}`]: '',
      [`input${INSURANCE_COMMERCIAL_COMPANY}`]: '',
      [`input${INSURANCE_COMMERCIAL_POLICY_NUMBER}`]: '',
      [`input${INSURANCE_MEDICARE}`]: '',
      [`input${INSURANCE_MEDICARE_MEDICARE_ID}`]: '',
      [`input${INSURANCE_MEDICAID}`]: '',
      [`input${INSURANCE_MEDICAID_MEDICAID_ID}`]: '',
      [`input${INSURANCE_OTHER}`]: '',
      [`input${INSURANCE_OTHER_DETAILS}`]: '',
      [`input${INSURANCE_OTHER_GROUP_ID}`]: '',
      [`input${INSURANCE_OTHER_MONITORING_FREQUENCY}`]: '',
      [`input${INSURANCE_OTHER_RX_BIN}`]: '',
      [`input${SOCIAL_SECURITY}`]: '',
      [`input${CONDITION1}`]: '',
      [`input${CONDITION2}`]: '',
      [`input${BLOOD_PRESSURE}`]: false,
      [`input${CARDIAC_CARE}`]: false,
      [`input${HEART_RATE}`]: false,
      [`input${EKG}`]: false,
      [`input${PLATELET}`]: false,
      [`input${PULSE_OXIMETRY}`]: false,
      [`input${GLUCOSE}`]: false,
      [`input${TEMPERATURE}`]: false,
      [`input${WEIGHT}`]: false,
      [`input${URINE_TOXICOLOGY}`]: false,
      [`input${WBC}`]: false,
      [`selected${SITE}`]: null,
      [`selected${PRESCRIBER}`]: null,
      [`selected${PATIENT_TYPE}`]: null,
      [`input${CARETAKER_NAME}`]: '',
      [`selected${SITE_EDIT}`]: null,
      [`selected${PATIENT_EDIT}`]: null,
      [`input${SITE_EDIT}`]: null,
      [`input${PATIENT_EDIT}`]: null,
      [`input${IS_RPM}`]: false,
      [`input${IS_CARDIAC_CARE_ENABLED}`]: false,
      [`input${IS_CONCIERGE}`]: false,
      addressSelected: false,
      insuranceKinds: [],
      disableSubmit: false,
      incomplete: [],
      selectedFile: null,
      patientsEdit: [],
      [`input${BLOOD_PRESSURE_EDIT}`]: false,
      [`input${HEART_RATE_EDIT}`]: false,
      [`input${EKG_EDIT}`]: false,
      [`input${PLATELET_EDIT}`]: false,
      [`input${PULSE_OXIMETRY_EDIT}`]: false,
      [`input${GLUCOSE_EDIT}`]: false,
      [`input${TEMPERATURE_EDIT}`]: false,
      [`input${WEIGHT_EDIT}`]: false,
      [`input${URINE_TOXICOLOGY_EDIT}`]: false,
      [`input${WBC_EDIT}`]: false,
      disableEditSubmit: false,
      disableUploadSubmit: false,
    }
  }

  // check to see if requirements are met before enabling user to take action, true if prereqs met
  checkPrereqs = (resourceType) => {
    const {
      inputFirstName,
      inputLastName,
      selectedSite,
      selectedPrescriber,
      inputDateOfBirth,
      selectedPatientType,
      inputAddress
    } = this.state

    if (inputFirstName !== '' && inputLastName !== '' && selectedPrescriber !== null && selectedSite !== null && inputDateOfBirth !== '') {
      if (selectedPatientType && selectedPatientType.value === 'Concierge') {
        if (inputAddress === '') {
          return false
        }
      }
      return true
    }
    return false
  }

  handleSelect = (resourceType, selected) => {

    console.log("Select", resourceType, selected)

    if (selected == null) {
      selected = ''
    }

    this.setState({ [`selected${resourceType}`]: selected })

    if (resourceType === SITE_EDIT) {
      this.props.getPatients(selected.id)
    }

    if (resourceType === PATIENT_EDIT && selected && selected.test_types) {
      this.setState({
        inputBloodPressureEdit: selected.test_types.blood_pressure_test_enabled,
        inputEKGEdit: selected.test_types.ekg_test_enabled,
        inputGlucoseEdit: selected.test_types.glucose_test_enabled,
        inputHeartRateEdit: selected.test_types.heart_rate_test_enabled,
        inputPlateletEdit: selected.test_types.platelet_test_enabled,
        inputPulseOximetryEdit: selected.test_types.pulse_oximetry_test_enabled,
        inputTemperatureEdit: selected.test_types.temperature_test_enabled,
        inputWBCEdit: selected.test_types.wbc_test_enabled,
        inputWeightEdit: selected.test_types.weight_test_enabled,
        inputUrineToxicologyEdit: selected.test_types.urine_toxicology_test_enabled,
      })
    }
  }

  handleDateSelect = (selected) => {
    this.setState({ inputDateOfBirth: selected })
  }

  handleInput = (resourceType, input) => {
    this.setState({ [`input${resourceType}`]: input })
    return input
  }

  handleCheck = (resourceType, e) => {
    console.log("Check", resourceType, e)
    this.setState({ [`input${resourceType}`]: e })
  }

  handleInsuranceCheck = (resourceType, e) => {
    this.setState({
      [`input${resourceType}`]: e
    })

    const vals = {
      InsuranceCommercial: 'Commercial',
      InsuranceMedicaid: 'Medicaid',
      InsuranceMedicare: 'Medicare',
      InsuranceOther: 'Other'
    }

    if (e === true) {
      this.setState({
        insuranceKinds: [...this.state.insuranceKinds, vals[resourceType]]
      })
    } else {
      var array = [...this.state.insuranceKinds]
      var index = array.indexOf(vals[resourceType])
      if (index !== -1) {
        array.splice(index, 1)
        this.setState({ insuranceKinds: array })
      }
    }
  }

  handleAddressChange = (address) => {
    this.setState({
      inputAddress: address,
    })

    if (address === '') {
      this.setState({
        addressSelected: false
      })
    }
  }

  handleAddressSelect = (address) => {
    this.setState({
      inputAddress: address,
      addressSelected: true
    })

    geocodeByAddress(address)
    .then(results => getLatLng(results[0]))
    .then((res) => {
      this.setState({
        addressSelectedLat: res.lat,
        addressSelectedLon: res.lng,
      })
    })
  }

  handleUpdatePatientTests = () => {

    this.setState({ disableEditSubmit: true })

    const {
      selectedPatientEdit,
      inputBloodPressureEdit,
      inputEKGEdit,
      inputGlucoseEdit,
      inputHeartRateEdit,
      inputPlateletEdit,
      inputPulseOximetryEdit,
      inputTemperatureEdit,
      inputWBCEdit,
      inputWeightEdit,
      inputUrineToxicologyEdit,
    } = this.state

    const {
      updatePatient
    } = this.props

    updatePatient(selectedPatientEdit.id, {
      blood_pressure_test_enabled: inputBloodPressureEdit,
      ekg_test_enabled: inputEKGEdit,
      glucose_test_enabled: inputGlucoseEdit,
      heart_rate_test_enabled: inputHeartRateEdit,
      platelet_test_enabled: inputPlateletEdit,
      pulse_oximetry_test_enabled: inputPulseOximetryEdit,
      temperature_test_enabled: inputTemperatureEdit,
      wbc_test_enabled: inputWBCEdit,
      weight_test_enabled: inputWeightEdit,
      urine_toxicology_test_enabled: inputUrineToxicologyEdit
    }).then((response) => {
      this.setState({ disableEditSubmit:false })
      alert('Saved')
    }).catch(() => {
      this.setState({ disableEditSubmit:false })
      alert('There was an error saving the tests')
    })
  }

  handleCreatePatient = () => {
    const {
      inputFirstName,
      inputLastName,
      inputDateOfBirth,
      selectedGender,
      selectedRace,
      inputPhoneNumber,
      selectedPhoneNumberType,
      inputEmail,
      inputAddress,
      addressSelectedLat,
      addressSelectedLon,
      inputInsuranceCommercialCompany,
      inputInsuranceCommercialPolicyNumber,
      inputInsuranceMedicareMedicareId,
      inputInsuranceMedicaidMedicaidId,
      inputInsuranceOtherDetails,
      inputInsuranceOtherGroupId,
      inputInsuranceOtherMonitoringFrequency,
      inputInsuranceOtherRxBin,
      insuranceKinds,
      selectedSite,
      selectedPrescriber,
      selectedPatientType,
      inputCondition1,
      inputCondition2,
      inputBloodPressure,
      inputCardiacCare,
      inputEKG,
      inputGlucose,
      inputHeartRate,
      inputPlatelet,
      inputPulseOximetry,
      inputTemperature,
      inputWBC,
      inputWeight,
      inputUrineToxicology,
      inputSocialSecurity,
      inputCaretakerName,
      inputIsConcierge,
      inputIsRPM,
      inputIsCardiacCareEnabled,
      incomplete
    } = this.state
    const { createPatient, router } = this.props
    this.setState({ disableSubmit: true })

    let emailResult
    if (inputEmail !== '') {
      emailResult = validation.validateEmail(inputEmail)
    } else {
      emailResult = { valid: true, errors: '' }
    }

    let phoneResult
    if (inputPhoneNumber !== '') {
      phoneResult = validation.validatePhoneNumber(inputPhoneNumber)
    } else {
      phoneResult = { valid: true, errors: '' }
    }

    this.setState({
      [`alert${EMAIL}`]: {
        show: !emailResult.valid,
        errors: emailResult.errors
      },
      [`alert${PHONE_NUMBER}`]: {
        show: !phoneResult.valid,
        errors: phoneResult.errors
      }
    })

    if (emailResult.valid === false || phoneResult.valid === false) {
      this.setState({ disableSubmit: false })
      return
    }

    var inc = []

    if (inputFirstName === '') {
      inc.push('Please input First Name')
    }

    if (inputLastName === '') {
      inc.push('Please input Last Name')
    }

    if (selectedSite === null) {
      inc.push('Please select a Site')
    }

    if (selectedPrescriber === null) {
      inc.push('Please select a Prescriber')
    }

    if (inputDateOfBirth === '') {
      inc.push('Please input Date of Birth')
    }

    if (selectedPatientType && selectedPatientType.value === 'Concierge' && inputAddress == '') {
      inc.push('Please select an address')
    }

    this.setState({ incomplete: inc })

    var month = '' + (inputDateOfBirth.getMonth() + 1)
    var day = '' + inputDateOfBirth.getDate()
    var year = inputDateOfBirth.getFullYear()

    if (month.length < 2) {
      month = '0' + month
    }

    if (day.length < 2) {
      day = '0' + day
    }

    var dateOfBirth = [year, month, day].join('-')

    if (emailResult.valid && phoneResult.valid) {
      createPatient(
        inputFirstName,
        inputLastName,
        dateOfBirth,
        inputPhoneNumber,
        selectedPhoneNumberType ? selectedPhoneNumberType.value : null,
        inputEmail,
        inputAddress,
        addressSelectedLat,
        addressSelectedLon,
        selectedRace ? selectedRace.value : null,
        selectedGender ? selectedGender.value : null,
        selectedPrescriber.id,
        selectedSite.id,
        inputCondition1,
        inputCondition2,
        inputBloodPressure,
        inputCardiacCare,
        inputEKG,
        inputGlucose,
        inputHeartRate,
        inputPlatelet,
        inputPulseOximetry,
        inputTemperature,
        inputWBC,
        inputWeight,
        inputUrineToxicology,
        selectedPatientType ? selectedPatientType.value : null,
        insuranceKinds,
        inputInsuranceCommercialCompany,
        inputInsuranceCommercialPolicyNumber,
        inputInsuranceMedicareMedicareId,
        inputInsuranceMedicaidMedicaidId,
        inputInsuranceOtherDetails,
        inputInsuranceOtherGroupId,
        inputInsuranceOtherMonitoringFrequency,
        inputInsuranceOtherRxBin,
        inputSocialSecurity,
        inputCaretakerName,
        inputIsConcierge,
        inputIsRPM,
        inputIsCardiacCareEnabled
      ).then(function (response) {
        alert('Patient Created')

        console.log(response)

        if (selectedPatientType.value === 'Concierge') {
          router.push('/concierge#SCHEDULE_APPOINTMENT&' + selectedSite.id + '&' + response.id)
        }

        this.setState({ disableSubmit: false })
      })
    }
  }

  handleFileSelect = (event) => {
    this.setState({ selectedFile: event.target.files[0] })
  }

  handleUploadCSVRPM = (e) => {
    e.preventDefault()
    this.setState({ disableUploadSubmit: true })

    var data = new FormData()
    data.append('patients', this.state.selectedFile)

    console.log(this.state.selectedFile)

    return axios.post(`https://api.athelas.com/tooling/rpm/import_patients`, data).then((response) => {
      alert(JSON.stringify(response.data));
      this.setState({ disableUploadSubmit: false })
    }).catch((error) => {
      console.log(error.response)
      alert(`CSV Format Error: ${error.response.data}`)
      this.setState({ disableUploadSubmit: false})
    })
  }


  handleUploadCSV = (e) => {
    e.preventDefault()
    this.setState({ disableUploadSubmit: true })

    var data = new FormData()
    data.append('patients', this.state.selectedFile)

    console.log(this.state.selectedFile)

    return axios.post(`https://api.athelas.com/tooling/concierge/import_patients`, data).then((response) => {
      alert(JSON.stringify(response.data));
      this.setState({ disableUploadSubmit: false })
    }).catch((error) => {
      console.log(error.response)
      alert(`CSV Format Error: ${error.response.data}`)
      this.setState({ disableUploadSubmit: false})
    })
  }

  renderAlert = (resourceType) => {
    const alert = this.state[`alert${resourceType}`]
    if (alert && alert.show) {
      return _.map(alert.errors, (error, index) => (
        <div className='alert alert-danger' key={index}>{error}</div>
      ))
    }
  }

  render () {
    const {
      isFetchingSites,
      isFetchingPrescribers,
      sites,
      prescribers,
      patients,
      isFetchingPatients,
    } = this.props
    const {
      inputFirstName,
      inputLastName,
      inputPhoneNumber,
      selectedPhoneNumberType,
      inputEmail,
      inputAddress,
      inputCondition1,
      inputCondition2,
      inputBloodPressure,
      inputCardiacCare,
      inputEKG,
      inputGlucose,
      inputHeartRate,
      inputPlatelet,
      inputPulseOximetry,
      inputTemperature,
      inputWBC,
      inputWeight,
      inputUrineToxicology,
      selectedSite,
      selectedPrescriber,
      addressSelected,
      selectedRace,
      selectedGender,
      selectedPatientType,
      inputDateOfBirth,
      inputInsuranceCommercial,
      inputInsuranceCommercialCompany,
      inputInsuranceCommercialPolicyNumber,
      inputInsuranceMedicare,
      inputInsuranceMedicareMedicareId,
      inputInsuranceMedicaid,
      inputInsuranceMedicaidMedicaidId,
      inputInsuranceOther,
      inputInsuranceOtherDetails,
      inputInsuranceOtherMonitoringFrequency,
      inputInsuranceOtherRxBin,
      inputInsuranceOtherGroupId,
      inputSocialSecurity,
      inputCaretakerName,
      inputIsConcierge,
      inputIsRPM,
      inputIsCardiacCareEnabled,
      incomplete,
      selectedSiteEdit,
      selectedPatientEdit,
      inputBloodPressureEdit,
      inputEKGEdit,
      inputGlucoseEdit,
      inputHeartRateEdit,
      inputPlateletEdit,
      inputPulseOximetryEdit,
      inputTemperatureEdit,
      inputWBCEdit,
      inputWeightEdit,
      inputUrineToxicologyEdit,
    } = this.state

    var patientsList = Object.values(patients)

    for (var i = 0; i < patientsList.length; i++) {
      patientsList[i].full_name = `${patientsList[i].first_name} ${patientsList[i].last_name}`
    }

    return (
      <div className='step-form'>
        <div>
          <Step
            title='Upload Patient CSV for RPM'
          >
            <div>
              <div>Select RPM File</div>
              <p><a href='https://docs.google.com/spreadsheets/d/1kWRLpMPtehUKbwI4jUbyjdCXu6qGPsQ1uTTMd1QQd-w/edit?usp=sharing'>Link to template </a></p>
              <input type='file' name='patient_csv' name='patient_csv' accept='.csv' onChange={this.handleFileSelect} />
              <br />
              <br />
              <button
                className='btn btn-primary action-button'
                onClick={(e) => this.handleUploadCSVRPM(e)}
                disabled={this.state.disableUploadSubmit}
              >
                Create Patient
              </button>
            </div>
          </Step>
          <Step
            title='Upload Patient CSV for Non-RPM'
          >
            <div>
              <div>Select File</div>
              <p><a href='https://docs.google.com/spreadsheets/d/1kWRLpMPtehUKbwI4jUbyjdCXu6qGPsQ1uTTMd1QQd-w/edit?usp=sharing'>Link to template </a></p>
              <input type='file' name='patient_csv' name='patient_csv' accept='.csv' onChange={this.handleFileSelect} />
              <br />
              <br />
              <button
                className='btn btn-primary action-button'
                onClick={(e) => this.handleUploadCSV(e)}
                disabled={this.state.disableUploadSubmit}
              >
                Create Patient
              </button>
            </div>
          </Step>
          <Step
            title='Create Patient'
          >
            {
              <div>
                <br />
                <h4>Basic Information</h4>
                <div>First Name <span style={{ color: 'red' }}>*</span></div>
                <input
                  type='text'
                  className='input'
                  value={inputFirstName}
                  onChange={(event) => this.handleInput(FIRST_NAME, event.target.value)}
                />
                <br />
                <div>Last Name <span style={{ color: 'red' }}>*</span></div>
                <input
                  type='text'
                  className='input'
                  value={inputLastName}
                  onChange={(event) => this.handleInput(LAST_NAME, event.target.value)}
                />
                <br />
                <div>Date of Birth <span style={{ color: 'red' }}>*</span></div>
                <DatePicker
                  selected={inputDateOfBirth}
                  onSelect={this.handleDateSelect}
                />
                <div>Gender</div>
                <Select
                  options={[{ label: 'Female', value: 'Female' }, { label: 'Male', value: 'Male' }]}
                  value={selectedGender}
                  onChange={(selected) => this.handleSelect(GENDER, selected)}
                  onInputChange={(input) => this.handleInput(GENDER, input)}
                  onBlurResetsInput={false}
                  onCloseResetsInput={false}
                  noResultsText={false}
                  labelKey={'label'}
                  valueKey={'value'}
                />
                <div>Race</div>
                <Select
                  options={[
                    { label: 'African American', value: 'African American' },
                    { label: 'Asian', value: 'Asian' },
                    { label: 'Caucasian', value: 'Caucasian' },
                    { label: 'Hispanic', value: 'Hispanic' },
                    { label: 'Other', value: 'Other' }
                  ]}
                  value={selectedRace}
                  onChange={(selected) => this.handleSelect(RACE, selected)}
                  onInputChange={(input) => this.handleInput(RACE, input)}
                  onBlurResetsInput={false}
                  onCloseResetsInput={false}
                  noResultsText={false}
                  labelKey={'label'}
                  valueKey={'value'}
                />
                <br />
                <h4>Contact Information</h4>
                <div>Phone Number <span style={{ color: 'red' }}>*</span></div>
                <input
                  type='text'
                  className='input'
                  value={inputPhoneNumber}
                  onChange={(event) => this.handleInput(PHONE_NUMBER, event.target.value)}
                />
                { this.renderAlert(PHONE_NUMBER) }
                <div>Phone Number Type <span style={{ color: 'red' }}>*</span></div>
                <Select
                  options={[{ label: 'Landline', value: 'landline' }, { label: 'Mobile', value: 'mobile' }]}
                  value={selectedPhoneNumberType}
                  onChange={(selected) => this.handleSelect(PHONE_NUMBER_TYPE, selected)}
                  onInputChange={(input) => this.handleInput(PHONE_NUMBER_TYPE, input)}
                  onBlurResetsInput={false}
                  onCloseResetsInput={false}
                  noResultsText={false}
                  labelKey={'label'}
                  valueKey={'value'}
                />
                <br />
                <div>Email <span style={{ color: 'red' }}>*</span></div>
                <input
                  type='text'
                  className='input'
                  value={inputEmail}
                  onChange={(event) => this.handleInput(EMAIL, event.target.value)}
                />
                <div>Caretaker Name</div>
                <input
                  type='text'
                  className='input'
                  value={inputCaretakerName}
                  onChange={(event) => this.handleInput(CARETAKER_NAME, event.target.value)}
                />
                <br />
                { this.renderAlert(EMAIL) }
                <br />
                <div>Address <span style={{ color: 'red' }}>*</span></div>
                <PlacesAutocomplete
                  onChange={this.handleAddressChange}
                  value={inputAddress}
                  onSelect={this.handleAddressSelect}
                  onError={this.handleError}
                  shouldFetchSuggestions={inputAddress.length > 2}
                >
                  {({ getInputProps, suggestions, getSuggestionItemProps }) => {
                    return (
                      <div className='Demo__search-bar-container'>
                        <div className='Demo__search-input-container'>
                          <input
                            {...getInputProps({
                              placeholder: 'Search Places...',
                              className: 'Demo__search-input',
                            })}
                          />
                        </div>
                        {suggestions.length > 0 ? (
                          <div className='Demo__autocomplete-container'>
                            {suggestions.map(suggestion => {
                              return (
                                /* eslint-disable react/jsx-key */
                                <div
                                  {...getSuggestionItemProps(suggestion)}
                                >
                                  <strong>
                                    {suggestion.formattedSuggestion.mainText}
                                  </strong>{' '}
                                  <small>
                                    {suggestion.formattedSuggestion.secondaryText}
                                  </small>
                                </div>
                              )
                              /* eslint-enable react/jsx-key */
                            })}
                          </div>
                          ) : (
                            <div>
                              {
                                inputAddress.length > 2 && addressSelected === false ? <BeatLoader /> : null
                              }
                            </div>
                          )
                        }
                      </div>
                    )
                  }}
                </PlacesAutocomplete>
                <br />
                <h4>Insurance Information</h4>
                <div>
                  <input
                    className='form-check-input'
                    type='checkbox' checked={inputInsuranceCommercial}
                    onChange={(e) => this.handleInsuranceCheck(INSURANCE_COMMERCIAL, e.target.checked)}
                  />
                  <p>Commercial</p>
                  { inputInsuranceCommercial ? (
                    <div>
                      <div>Insurance Company</div>
                      <input
                        type='text'
                        value={inputInsuranceCommercialCompany}
                        onChange={(event) => this.handleInput(INSURANCE_COMMERCIAL_COMPANY, event.target.value)} />
                      <div>Policy Number</div>
                      <input
                        type='text'
                        value={inputInsuranceCommercialPolicyNumber}
                        onChange={(event) => {
                          this.handleInput(INSURANCE_COMMERCIAL_POLICY_NUMBER, event.target.value)
                        }} />
                      <br />
                    </div>
                    ) : null
                  }
                </div>
                <div>
                  <input
                    className='form-check-input'
                    type='checkbox' checked={inputInsuranceMedicare}
                    onChange={(e) => this.handleInsuranceCheck(INSURANCE_MEDICARE, e.target.checked)}
                  />
                  <p>Medicare</p>
                  { inputInsuranceMedicare ? (
                    <div>
                      <div>Medicare Id</div>
                      <input
                        type='text'
                        value={inputInsuranceMedicareMedicareId}
                        onChange={(event) => this.handleInput(INSURANCE_MEDICARE_MEDICARE_ID, event.target.value)} />
                      <br />
                    </div>
                    ) : null
                  }
                </div>
                <div>
                  <input
                    className='form-check-input'
                    type='checkbox' checked={inputInsuranceMedicaid}
                    onChange={(e) => this.handleInsuranceCheck(INSURANCE_MEDICAID, e.target.checked)}
                  />
                  <p>Medicaid</p>
                  { inputInsuranceMedicaid ? (
                    <div>
                      <div>Medicaid Id</div>
                      <input
                        type='text'
                        value={inputInsuranceMedicaidMedicaidId}
                        onChange={(event) => this.handleInput(INSURANCE_MEDICAID_MEDICAID_ID, event.target.value)} />
                      <br />
                    </div>
                    ) : null
                  }
                </div>
                <div>
                  <input
                    className='form-check-input'
                    type='checkbox' checked={inputInsuranceOther}
                    onChange={(e) => this.handleInsuranceCheck(INSURANCE_OTHER, e.target.checked)}
                  />
                  <p>Other</p>
                  { inputInsuranceOther ? (
                    <div>
                      <div>Insurance Details</div>
                      <input
                        type='text'
                        value={inputInsuranceOtherDetails}
                        onChange={(event) => this.handleInput(INSURANCE_OTHER_DETAILS, event.target.value)} />
                      <div>Group Id</div>
                      <input
                        type='text'
                        value={inputInsuranceOtherGroupId}
                        onChange={(event) => this.handleInput(INSURANCE_OTHER_GROUP_ID, event.target.value)} />
                      <div>Monitoring Frequency</div>
                      <input
                        type='text'
                        value={inputInsuranceOtherMonitoringFrequency}
                        onChange={(event) => {
                          this.handleInput(INSURANCE_OTHER_MONITORING_FREQUENCY, event.target.value)
                        }} />
                      <div>Rx Bin</div>
                      <input
                        type='text'
                        value={inputInsuranceOtherRxBin}
                        onChange={(event) => this.handleInput(INSURANCE_OTHER_RX_BIN, event.target.value)} />
                      <br />
                    </div>
                    ) : null
                  }
                </div>
                <div>Social Security Number</div>
                <input
                  type='text'
                  value={inputSocialSecurity}
                  onChange={(event) => this.handleInput(SOCIAL_SECURITY, event.target.value)} />
                <h4>Prescriber Information</h4>
                <div>Site <span style={{ color: 'red' }}>*</span></div>
                <Select
                  isSearchable
                  isClearable
                  isLoading={isFetchingSites}
                  options={sites}
                  value={selectedSite}
                  onChange={(selected) => this.handleSelect(SITE, selected)}
                  onInputChange={(input) => this.handleInput(SITE, input)}
                  onBlurResetsInput={false}
                  onCloseResetsInput={false}
                  noResultsText={false}
                  labelKey={'name'}
                  valueKey={'site_id'}
                />
                <div>Prescriber <span style={{ color: 'red' }}>*</span></div>
                <Select
                  isSearchable
                  isClearable
                  isLoading={isFetchingPrescribers}
                  options={prescribers}
                  value={selectedPrescriber}
                  onChange={(selected) => this.handleSelect(PRESCRIBER, selected)}
                  onInputChange={(input) => this.handleInput(PRESCRIBER, input)}
                  onBlurResetsInput={false}
                  onCloseResetsInput={false}
                  noResultsText={false}
                  labelKey={'name'}
                  valueKey={'prescriber_id'}
                />
                <br />
                <div>Patient Type</div>
                <Select
                  options={[
                    { label: 'Inpatient', value: 'Inpatient' },
                    { label: 'Outpatient', value: 'Outpatient' },
                  ]}
                  value={selectedPatientType}
                  onChange={(selected) => this.handleSelect(PATIENT_TYPE, selected)}
                  onInputChange={(input) => this.handleInput(PATIENT_TYPE, input)}
                  onBlurResetsInput={false}
                  onCloseResetsInput={false}
                  noResultsText={false}
                  labelKey={'label'}
                  valueKey={'value'}
                />
                <br />
                <h4>Other</h4>
                <div>Condition 1</div>
                <input
                  type='text'
                  className='input'
                  value={inputCondition1}
                  onChange={(event) => this.handleInput(CONDITION1, event.target.value)}
                />
                <div>Condition 2</div>
                <input
                  type='text'
                  className='input'
                  value={inputCondition2}
                  onChange={(event) => this.handleInput(CONDITION2, event.target.value)}
                />
                <br />
                <br />
                <div>Programs <span style={{ color: 'red' }}>*</span></div>
                <input
                  className='form-check-input'
                  type='checkbox' checked={inputIsConcierge}
                  onChange={(e) => this.handleCheck(IS_CONCIERGE, e.target.checked)}
                />
                <p>Concierge?</p>
                <input
                  className='form-check-input'
                  type='checkbox' checked={inputIsRPM}
                  onChange={(e) => this.handleCheck(IS_RPM, e.target.checked)}
                />
                <p>RPM?</p>
                <input
                  className='form-check-input'
                  type='checkbox' checked={inputIsCardiacCareEnabled}
                  onChange={(e) => this.handleCheck(IS_CARDIAC_CARE_ENABLED, e.target.checked)}
                />
                <p>Cardiac Care?</p>
                <br />
                <br />
                <div>Tests <span style={{ color: 'red' }}>*</span></div>
                <input
                  className='form-check-input'
                  type='checkbox' checked={inputBloodPressure}
                  onChange={(e) => this.handleCheck(BLOOD_PRESSURE, e.target.checked)}
                />
                <p>Blood Pressure</p>

                <input
                  className='form-check-input'
                  type='checkbox' checked={inputCardiacCare}
                  onChange={(e) => this.handleCheck(CARDIAC_CARE, e.target.checked)}
                />
                <p>Cardiac Care Weight</p>
                <input
                  className='form-check-input'
                  type='checkbox' checked={inputEKG}
                  onChange={(e) => this.handleCheck(EKG, e.target.checked)}
                />
                <p>EKG</p>

                <input
                  className='form-check-input'
                  type='checkbox' checked={inputHeartRate}
                  onChange={(e) => this.handleCheck(HEART_RATE, e.target.checked)}
                />
                <p>Heart Rate</p>

                <input
                  className='form-check-input'
                  type='checkbox' checked={inputGlucose}
                  onChange={(e) => this.handleCheck(GLUCOSE, e.target.checked)}
                />
                <p>Glucose</p>

                <input
                  className='form-check-input'
                  type='checkbox' checked={inputPlatelet}
                  onChange={(e) => this.handleCheck(PLATELET, e.target.checked)}
                />
                <p>Platelet</p>

                <input
                  className='form-check-input'
                  type='checkbox' checked={inputPulseOximetry}
                  onChange={(e) => this.handleCheck(PULSE_OXIMETRY, e.target.checked)}
                />
                <p>Pulse Oximetry</p>

                <input
                  className='form-check-input'
                  type='checkbox' checked={inputTemperature}
                  onChange={(e) => this.handleCheck(TEMPERATURE, e.target.checked)}
                />
                <p>Temperature</p>

                <input
                  className='form-check-input'
                  type='checkbox' checked={inputWBC}
                  onChange={(e) => this.handleCheck(WBC, e.target.checked)}
                />
                <p>WBC</p>

                <input
                  className='form-check-input'
                  type='checkbox' checked={inputWeight}
                  onChange={(e) => this.handleCheck(WEIGHT, e.target.checked)}
                />
                <p>Weight</p>

                <input
                  className='form-check-input'
                  type='checkbox' checked={inputUrineToxicology}
                  onChange={(e) => this.handleCheck(URINE_TOXICOLOGY, e.target.checked)}
                />
                <p>Urine Toxicology</p>

                <div className='button-container'>
                  <button
                    className='btn btn-primary action-button'
                    onClick={() => this.handleCreatePatient()}
                    disabled={!this.checkPrereqs() || this.state.disableSubmit}
                  >
                    Create Patient
                  </button>
                  <ul>
                    {incomplete.map((item, index) => (
                      <li>item</li>
                    ))}
                  </ul>
                </div>
              </div>
            }
          </Step>
          <Step
            title='Edit Patient Tests'
            >
            <div>
              <div>Site <span style={{ color: 'red' }}>*</span></div>
              <Select
                isSearchable
                isClearable
                isLoading={isFetchingSites}
                options={sites}
                value={selectedSiteEdit}
                onChange={(selected) => this.handleSelect(SITE_EDIT, selected)}
                onInputChange={(input) => this.handleInput(SITE_EDIT, input)}
                onBlurResetsInput={false}
                onCloseResetsInput={false}
                noResultsText={false}
                labelKey={'name'}
                valueKey={'site_id'}
              />
              <div>Patient <span style={{ color: 'red' }}>*</span></div>
              <Select
                isSearchable
                isClearable
                isLoading={isFetchingPatients}
                options={patientsList}
                value={selectedPatientEdit}
                onChange={(selected) => this.handleSelect(PATIENT_EDIT, selected)}
                onInputChange={(input) => this.handleInput(PATIENT_EDIT, input)}
                onBlurResetsInput={false}
                onCloseResetsInput={false}
                noResultsText={false}
                labelKey={'full_name'}
                valueKey={'id'}
              />

              <input
                className='form-check-input'
                type='checkbox' checked={inputBloodPressureEdit}
                onChange={(e) => this.handleCheck(BLOOD_PRESSURE_EDIT, e.target.checked)}
              />
              <p>Blood Pressure</p>

              <input
                className='form-check-input'
                type='checkbox' checked={inputEKGEdit}
                onChange={(e) => this.handleCheck(EKG_EDIT, e.target.checked)}
              />
              <p>EKG</p>

              <input
                className='form-check-input'
                type='checkbox' checked={inputHeartRateEdit}
                onChange={(e) => this.handleCheck(HEART_RATE_EDIT, e.target.checked)}
              />
              <p>Heart Rate</p>

              <input
                className='form-check-input'
                type='checkbox' checked={inputGlucoseEdit}
                onChange={(e) => this.handleCheck(GLUCOSE_EDIT, e.target.checked)}
              />
              <p>Glucose</p>

              <input
                className='form-check-input'
                type='checkbox' checked={inputPlateletEdit}
                onChange={(e) => this.handleCheck(PLATELET_EDIT, e.target.checked)}
              />
              <p>Platelet</p>

              <input
                className='form-check-input'
                type='checkbox' checked={inputPulseOximetryEdit}
                onChange={(e) => this.handleCheck(PULSE_OXIMETRY_EDIT, e.target.checked)}
              />
              <p>Pulse Oximetry</p>

              <input
                className='form-check-input'
                type='checkbox' checked={inputTemperatureEdit}
                onChange={(e) => this.handleCheck(TEMPERATURE_EDIT, e.target.checked)}
              />
              <p>Temperature</p>

              <input
                className='form-check-input'
                type='checkbox' checked={inputWBCEdit}
                onChange={(e) => this.handleCheck(WBC_EDIT, e.target.checked)}
              />
              <p>WBC</p>

              <input
                className='form-check-input'
                type='checkbox' checked={inputWeightEdit}
                onChange={(e) => this.handleCheck(WEIGHT_EDIT, e.target.checked)}
              />
              <p>Weight</p>

              <input
                className='form-check-input'
                type='checkbox' checked={inputUrineToxicologyEdit}
                onChange={(e) => this.handleCheck(URINE_TOXICOLOGY_EDIT, e.target.checked)}
              />
              <p>Urine Toxicology</p>

              <button
                className='btn btn-primary action-button'
                onClick={() => this.handleUpdatePatientTests()}
                disabled={selectedPatientEdit == null || this.state.disableEditSubmit}
              >
                Save
              </button>
            </div>
          </Step>
        </div>
      </div>
    )
  }
}

export default withRouter(PatientCreationView)



// WEBPACK FOOTER //
// ./src/routes/Clinic/components/PatientCreationView.jsx